import Lottie from "lottie-react";
import groovyWalkAnimation from "./groovyWalk.json";

const LottieAnimations = () => {
    return <Lottie animationData={groovyWalkAnimation} style={{ height: 100, width: 100 }} />
};

export default LottieAnimations;